import React from 'react';
import { Grid, Segment, Item, Header, List, Icon } from 'semantic-ui-react';
import format from 'date-fns/format';

const UserDetailedDescription = ({profile}) => {
  return (
     <Grid.Column width={12}>
        <Segment>
            <Grid columns={2}>
                <Grid.Column width={10}>
                    <Header icon='smile' content={`About ${profile.displayName}`}/>
                    <p>I am a: <strong>{profile.occupation}</strong></p>
                    <p>Originally from  {profile.origin} <strong></strong></p>
                    <p>Member Since: <strong>{format(profile.createdAt, 'D MMM YYYY')}</strong></p>
                    <p>{profile.about}</p>

                </Grid.Column>
                <Grid.Column width={6}>

                    <Header icon='heart outline' content='Interests'/>
                    <List>
                        { profile.interests ? 
                        profile.interests.map((interest, index) => (
                            <Item key={index}>
                            <Icon name='heart'/>
                            <Item.Content>{interest.toUpperCase()}</Item.Content>
                            </Item>
                        ))
                        :  
                        <Item>
                            <Icon name='heart'/>
                            <Item.Content>No Interests</Item.Content>
                        </Item>}
                    </List>
                </Grid.Column>
            </Grid>
        </Segment>
    </Grid.Column>
  )
}

export default UserDetailedDescription



// WEBPACK FOOTER //
// ./src/features/user/UserDetailed/UserDetailedDescription.jsx